module.exports = __webpack_public_path__ + "img/bank_icon8.aa78c03d.png";